import { styled } from '@mui/material/styles'
import Slider from '@mui/material/Slider'
import { fsColors } from '../../shared/constants'

const FsOFASlider = ({
  value,
  onChange,
  min,
  max,
  step,
  marks,
  formatter,
  disabled,
  moduleConfig,
}: any) => {
  const sliderColor = moduleConfig ? moduleConfig.fsColor.primary : fsColors.fsGray.primary
  const CustomSlider = styled(Slider)(({ theme }) => ({
    color: sliderColor,
    height: 2,
    padding: '5px 0',
    '& .MuiSlider-thumb': {
      height: 18,
      width: 18,
      backgroundColor: '#fff',
      border: `2px solid ${sliderColor}`,
      boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
      '&:focus, &:hover, &.Mui-active': {
        boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow:
            '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
        },
      },
    },
    '& .MuiSlider-valueLabel': {
      display: 'none'
    },
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-rail': {
      opacity: 0.5,
      backgroundColor: '#bfbfbf',
    },
    '& .MuiSlider-mark': {
      backgroundColor: '#bfbfbf',
      height: 8,
      width: 1,
      '&.MuiSlider-markActive': {
        opacity: 1,
        backgroundColor: 'currentColor',
      },
    },
    '& .MuiSlider-markLabel': {
      top: 15,
    },
  }))

  return (
    <CustomSlider
      aria-label="gap"
      defaultValue={value}
      onChange={(_, valu) => {
        onChange(valu as number)
      }}
      valueLabelFormat={(newValue: number) => formatter(marks[newValue].gap)}
      valueLabelDisplay="on"
      marks={marks.map((m: any, index: number) => ({
        value: index,
        label: formatter(m.gap),
      }))}
      step={null}
      min={min ?? 0}
      max={max}
      disabled={disabled}
    />
  )
}
export default FsOFASlider
